module.exports = __webpack_public_path__ + "4202d53d25c1ccd866eeecf9cd8e73af.gif";